const defaultPieChartColors = [
    '#E2553C',
    '#EBC73A',
    '#0076D6',
    '#927CCC',
    '#28864C',
    '#B3B3B3',
]

export const clientThemeSabre = {
    mainLayout: {
        backgroundColor: '#fafaf9',
        hover: {
            backgroundColor: '#E2553C',
        },
    },
    topBar: {
        backgroundColor: '',
        contrastText: '',
        contrastLinkText: '#0076D6',
        userIcon: 'red',
        brandLogo: {
            maxWidth: '160px',
            paddingTop: '',
        },
        menuBarIcon: {
            color: '#afafaf',
        },
    },
    sidebar: {
        fontSize: '14px',
        backgroundColor: '#333436',
        darkBackgroundColor: '#1f2024',
        sideMenuActive: {
            backgroundColor: '#4e5052',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#E2553C',
        stroke: '#E2553C',
        lineCharts: {
            stroke: '#E2553C',
            fill: '#E2553C',
        },
        areaCharts: {
            gradient: {
                start: '#E2553C',
                stop: '#E2553C',
            },
            stroke: '#E2553C',
            fill: '#E2553C',
            chargebacksByPostDateChart: {
                stroke: '#E2553C',
                fill: '#E2553C',
            },
            newAlertsByDateChart: [
                {
                    stroke: '#E2553C',
                    fill: '#E2553C20',
                },
                {
                    stroke: '#EBC73A',
                    fill: '#EBC73A20',
                },
                {
                    stroke: '#0076D6',
                    fill: '#0076D620',
                },
                {
                    stroke: '#927CCC',
                    fill: '#927CCC20',
                },
                {
                    stroke: '#28864C',
                    fill: '#28864C20',
                },
                {
                    stroke: '#B3B3B3',
                    fill: '#B3B3B320',
                },
            ],
        },
        barCharts: {
            fill: '#E2553C',
            lowestBar: '#EBC73A',
            byPlatformBarChart: { fill: '#E2553C' },
            byBinBarChart: { fill: '#E2553C' },
            ertsByRevenueChart: {
                bar1Fill: '#E2553C',
                bar2Fill: '#EBC73A',
            },
            averageTimetoFileDispute: { fill: '#E2553C' },
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: '#E2553C',
                lineColor: '#EBC73A',
            },
        },
        heatmapCharts: {
            casesFiled: {
                low: '#0076D6',
                mid: '#E2553C',
                high: '#EBC73A',
            },
        },
        pieCharts: {
            defaultPieChart: defaultPieChartColors,
            dashboardPieChart: defaultPieChartColors,
            byReasonCodePieChart: defaultPieChartColors,
            byReasonCodeDistributionPieChart: defaultPieChartColors,
            byCardTypePieChart: defaultPieChartColors,
            byLocationTypePieChart: defaultPieChartColors,
            byPlatformPerCardTypePieChart: defaultPieChartColors,
            byStatusPieChart: defaultPieChartColors,
            byWinLossPieChart: defaultPieChartColors,
        },
        radialBarCharts: {
            fill: '#E2553C',
        },
    },
    lockAndUnlockButton: {
        lockButton: {},
        unlockButton: {},
    },
    lampColors: {
        green: '#57a537',
        red: '#cb2022',
        orange: '#d87707',
        yellow: '#d8d800',
        grey: 'grey',
    },
    uploadDnD: {
        borderColor: `#cb2022`,
        backgroundColor: `rgba(203,32,34,.1)`,
        labelColor: `#cb2022`,
    },
    metricTile: {
        arrow: {
            width: 28,
            height: 28,
        },
    },
    caseBuilder: {
        color: '#E2553C',
        saveAndContinueBtn: {},
        submittingColor: '#E2553C',
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '',
        borderRadius: '',
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '8px 7px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '#27272a',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e4e4e7',
    },
    searchBar: {
        padding: '6px',
    },
    select: {
        hover: {
            color: 'inherit',
            backgroundColor: '#F4F4F4',
        },
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#e4e4e7',
                color: '#000',
                '&:hover': {
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid #DDE2EB !important',
                borderRadius: '4px !important',
                color: '#000',
                fontWeight: 500,
                padding: '4px 10px',
                fontSize: '13px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#71717a',
                borderRadius: '4px',
                backgroundColor: '#d4d4d8',
                '&:hover': {
                    color: '#71717a',
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                borderRadius: '4px',
                backgroundColor: '#31B98E',
                '&:hover': {
                    backgroundColor: '#23826F',
                },
            },
        },
        activeStateButton: {
            color: '#FFFFFF',
            backgroundColor: '#52525b',
        },
    },
    icons: {
        uploadIcon: '#3cb4e5',
        dnrAndRevertDnrIcon: '#3cb4e5',
        toggleUnlockIcon: '#75797b',
        toggleLockIcon: '#c80000',
        editUserIcon: '#2a7ea0',
        midPermissionIcon: '#714eb1',
        sitePermissionIcon: '#f88d2b',
        tempPasswordIcon: '#3cb4e5',
    },
    main: '#E2553C',
    primaryLight: '#E77763',
    primary: '#E2553C',
    primaryDark: '#9E3B2A',
    secondaryLight: '#E77763',
    secondary: '#E2553C',
    secondaryDark: '#9E3B2A',
    hyperlink: '#0076D6',
    textField: '#000',
    switch: '#E2553C',
    typography: {
        fontColor: {
            primaryText: '#000',
            secondaryText: '#000',
        },
        fontFamily: ['Roboto', 'sans-serif'],
        fontFamilyConfig: {
            primary: 'Roboto',
            fallback:
                '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Arial, sans-serif',
        },
        h1: {
            fontSize: '35px',
        },
        h2: {
            fontSize: '29px',
        },
        h3: {
            fontSize: '24px',
        },
        h4: {
            fontSize: '20px',
        },
        h5: {
            fontSize: '16px',
        },
        h6: {
            fontSize: '12px',
        },
        subtitle1: {
            fontSize: '16px',
        },
        subtitle2: {
            fontSize: '12px',
        },
        subtitle3: {
            fontSize: '15px',
        },
        subtitle4: {
            fontSize: '12px',
        },
        body1: {
            fontSize: '13px',
        },
        body2: {
            fontSize: '12px',
        },
        button1: {
            fontSize: '13px',
        },
        button2: {
            fontSize: '13px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '11px',
        },
        label: {
            fontSize: '13px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '13px',
                color: '#52525b',
            },
            tableExpandable: {
                fontSize: '13px',
            },
        },
    },
    shadows: {
        brandShadowLight: 'rgba(9, 167, 209, .4)',
    },
}
